export default {"src":"/uk/_next/static/media/trust-pilot-stars.8ae2ab8c.svg","height":35,"width":189,"blurWidth":0,"blurHeight":0};